import { render, staticRenderFns } from "./CopyrightDetails.vue?vue&type=template&id=21247208&scoped=true&"
import script from "./CopyrightDetails.vue?vue&type=script&lang=js&"
export * from "./CopyrightDetails.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightDetails.vue?vue&type=style&index=0&id=21247208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21247208",
  null
  
)

export default component.exports